import dashboardService from "../../../services/dashboardService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_GETOPENTICKETSBYMONTH } from "../../../utils/constants";
import { TicketsByMonth } from "../../../models/Dashboard";

const useGetOpenTicketsByMonth = (year: number) =>
  useQuery<TicketsByMonth[], Error>({
    queryKey: [CACHE_KEY_GETOPENTICKETSBYMONTH, year],
    queryFn: () => dashboardService.GetOpenTicketByMonth(year),
  });

export default useGetOpenTicketsByMonth;
